import { Stack } from "@mui/material";
import { ModalBase } from "./ModalBase";
import { DamsAppAsset } from "../../assets/registry";
import { OutlinedButton } from "../Button/AppButton";

interface ExportModalProps {
  show: boolean;
  onClose: () => void;
  onExportCSV: () => void;
  onExportPDF: () => void;
  isExportingCSV?: boolean;
  isExportingPDF?: boolean;
  title?: string;
  subtitle?: string;
}

export function ExportModal({
  show,
  onClose,
  onExportCSV,
  onExportPDF,
  isExportingCSV = false,
  isExportingPDF = false,
  title = "Export Data",
  subtitle = "Choose your preferred export format"
}: ExportModalProps) {
  return (
    <ModalBase
      open={show}
      title={title}
      subtitle={subtitle}
      type="add-item"
      showHeader={true}
      leftIcon={DamsAppAsset.icons.success}
      leftBtnTxt="Cancel"
      onLeftBtnPress={onClose}
      rightBtnTxt="Close"
      onRightBtnPress={onClose}
      onClose={onClose}
      width={400}
    >
      <Stack gap={2} marginTop={2}>
        <OutlinedButton
          height={48}
          title="Export as CSV"
          btnIconSrc={DamsAppAsset.icons.csv_icon}
          onClick={onExportCSV}
          loading={isExportingCSV}
          disabled={isExportingPDF}
        />
        
        <OutlinedButton
          height={48}
          title="Export as PDF"
          btnIconSrc={DamsAppAsset.icons.pdf_icon}
          onClick={onExportPDF}
          loading={isExportingPDF}
          disabled={isExportingCSV}
        />
      </Stack>
    </ModalBase>
  );
}